export default __webpack_public_path__ + "static/media/admin.8dbc48bc.svg";